import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _addScheduleItemRequest = { item: '_scheduleItemData' };
var _addScheduleItemResponse = { item: '_scheduleItem' };
var _createBookmarkRequest = {};
var _createBookmarkResponse = {};
var _deleteBookmarkRequest = {};
var _deleteBookmarkResponse = {};
var _deleteScheduleItemRequest = {};
var _deleteScheduleItemResponse = {};
var _discardDraftRequest = {};
var _discardDraftResponse = {};
var _getScheduleItemRequest = {};
var _getScheduleItemResponse = {
    item: '_scheduleItem',
    draft: '_scheduleItem',
};
var _listBookmarksRequest = {};
var _listBookmarksResponse = { items: '_scheduleItem' };
var _listScheduleItemsRequest = {
    startingFrom: 'google.protobuf.Timestamp',
    startingBefore: 'google.protobuf.Timestamp',
};
var _listScheduleItemsResponse = { items: '_scheduleItem' };
var _publishDraftRequest = {};
var _publishDraftResponse = {};
var _queryScheduleItemsRequest = {};
var _queryScheduleItemsResponse = { items: '_scheduleItem' };
var _rescheduleDraftRequest = { timeSlotOffset: 'google.protobuf.Duration' };
var _rescheduleDraftResponse = {};
var _scheduleItem = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    timeSlot: '_timeInterval',
};
var _scheduleItemData = { timeSlot: '_timeInterval' };
var _timeInterval = {
    start: 'google.protobuf.Timestamp',
    end: 'google.protobuf.Timestamp',
};
var _updateScheduleItemRequest = {
    fields: 'google.protobuf.FieldMask',
    item: '_scheduleItemData',
};
var _updateScheduleItemResponse = { item: '_scheduleItem' };
function resolveWixEventsScheduleBookmarkManagementUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/wix-events-agenda',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/wix-events-schedule/v1/schedule',
                destPath: '/v1/schedule',
            },
        ],
        _: [
            {
                srcPath: '/_api/wix-events-schedule/v1/schedule',
                destPath: '/v1/schedule',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/wix-events-schedule/v1/schedule',
                destPath: '/v1/schedule',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/wix-events-schedule/v1/schedule',
                destPath: '/v1/schedule',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/wix-events-schedule/v1/schedule',
                destPath: '/v1/schedule',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/wix-events-schedule/v1/schedule',
                destPath: '/v1/schedule',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/wix-events-schedule/v1/schedule',
                destPath: '/v1/schedule',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/wix-events-schedule/v1/schedule',
                destPath: '/v1/schedule',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/wix-events-schedule/v1/schedule',
                destPath: '/v1/schedule',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/events/v1/schedule',
                destPath: '/v1/schedule',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixEventsScheduleScheduleManagementUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/wix-events-agenda',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/wix-events-schedule/v1/schedule',
                destPath: '/v1/schedule',
            },
        ],
        _: [
            {
                srcPath: '/_api/wix-events-schedule/v1/schedule',
                destPath: '/v1/schedule',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/wix-events-schedule/v1/schedule',
                destPath: '/v1/schedule',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/wix-events-schedule/v1/schedule',
                destPath: '/v1/schedule',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/wix-events-schedule/v1/schedule',
                destPath: '/v1/schedule',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/wix-events-schedule/v1/schedule',
                destPath: '/v1/schedule',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/wix-events-schedule/v1/schedule',
                destPath: '/v1/schedule',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/wix-events-schedule/v1/schedule',
                destPath: '/v1/schedule',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/wix-events-schedule/v1/schedule',
                destPath: '/v1/schedule',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/events/v1/schedule',
                destPath: '/v1/schedule',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves a list of up to 100 schedule items, with basic filter support. */
export function listScheduleItems(payload) {
    var _a = serializer(_listScheduleItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listScheduleItemsResponse, {
        _scheduleItem: _scheduleItem,
        _timeInterval: _timeInterval,
    }).fromJSON;
    function __listScheduleItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.schedule.v1.schedule_item',
            method: 'GET',
            methodFqn: 'wix.events.schedule.ScheduleManagement.ListScheduleItems',
            url: resolveWixEventsScheduleScheduleManagementUrl({
                protoPath: '/v1/schedule',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listScheduleItems.fromReq = fromReq;
    __listScheduleItems.__isAmbassador = true;
    return __listScheduleItems;
}
/**
 * Retrieves a list of up to 100 schedule items, given the provided [paging](https://dev.wix.com/api/rest/getting-started/pagination), [filtering](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-schedule-items).
 *
 * * Important **:
 * - All results are for one specific business, resolved from the request context.
 *
 * Query object support:
 * - `filter` - supported, see [filtering and sorting](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-schedule-items).
 * - `sort` - supported, see [filtering and sorting](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-schedule-items).
 * - `paging` - supported, see [paging](https://dev.wix.com/api/rest/getting-started/pagination).
 * - `fields` - not supported.
 * - `fieldsets` - not supported.
 * - `cursorPaging` - not supported, use offset pagination instead.
 *
 * Defaults:
 * - When filter is not specified, returns all schedule items that caller is authorized to read.
 * - When sorting is not specified, defaults to `time_slot.start` and `time_slot.end` in `ASC` order.
 */
export function queryScheduleItems(payload) {
    var _a = serializer(_queryScheduleItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryScheduleItemsResponse, {
        _scheduleItem: _scheduleItem,
        _timeInterval: _timeInterval,
    }).fromJSON;
    function __queryScheduleItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.schedule.v1.schedule_item',
            method: 'POST',
            methodFqn: 'wix.events.schedule.ScheduleManagement.QueryScheduleItems',
            url: resolveWixEventsScheduleScheduleManagementUrl({
                protoPath: '/v1/schedule/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryScheduleItems.fromReq = fromReq;
    __queryScheduleItems.__isAmbassador = true;
    return __queryScheduleItems;
}
/** Retrieves schedule item by ID. */
export function getScheduleItem(payload) {
    var _a = serializer(_getScheduleItemRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getScheduleItemResponse, {
        _scheduleItem: _scheduleItem,
        _timeInterval: _timeInterval,
    }).fromJSON;
    function __getScheduleItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.schedule.v1.schedule_item',
            method: 'GET',
            methodFqn: 'wix.events.schedule.ScheduleManagement.GetScheduleItem',
            url: resolveWixEventsScheduleScheduleManagementUrl({
                protoPath: '/v1/schedule/{itemId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getScheduleItem.fromReq = fromReq;
    __getScheduleItem.__isAmbassador = true;
    return __getScheduleItem;
}
/** Adds schedule item to the draft schedule. Draft items are not publicly available unless published. */
export function addScheduleItem(payload) {
    var _a = serializer(_addScheduleItemRequest, { _scheduleItemData: _scheduleItemData, _timeInterval: _timeInterval }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addScheduleItemResponse, {
        _scheduleItem: _scheduleItem,
        _timeInterval: _timeInterval,
    }).fromJSON;
    function __addScheduleItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.schedule.v1.schedule_item',
            method: 'POST',
            methodFqn: 'wix.events.schedule.ScheduleManagement.AddScheduleItem',
            url: resolveWixEventsScheduleScheduleManagementUrl({
                protoPath: '/v1/schedule/draft',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addScheduleItem.fromReq = fromReq;
    __addScheduleItem.__isAmbassador = true;
    return __addScheduleItem;
}
/**
 * Updates existing schedule item.
 * All modifications are performed on a draft schedule, even if schedule item has already been published.
 */
export function updateScheduleItem(payload) {
    var _a = serializer(_updateScheduleItemRequest, { _scheduleItemData: _scheduleItemData, _timeInterval: _timeInterval }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateScheduleItemResponse, {
        _scheduleItem: _scheduleItem,
        _timeInterval: _timeInterval,
    }).fromJSON;
    function __updateScheduleItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.schedule.v1.schedule_item',
            method: 'PATCH',
            methodFqn: 'wix.events.schedule.ScheduleManagement.UpdateScheduleItem',
            url: resolveWixEventsScheduleScheduleManagementUrl({
                protoPath: '/v1/schedule/draft/{itemId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateScheduleItem.fromReq = fromReq;
    __updateScheduleItem.__isAmbassador = true;
    return __updateScheduleItem;
}
/** Deletes schedule item from draft schedule. */
export function deleteScheduleItem(payload) {
    var _a = serializer(_deleteScheduleItemRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteScheduleItemResponse, {}).fromJSON;
    function __deleteScheduleItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.schedule.v1.schedule_item',
            method: 'DELETE',
            methodFqn: 'wix.events.schedule.ScheduleManagement.DeleteScheduleItem',
            url: resolveWixEventsScheduleScheduleManagementUrl({
                protoPath: '/v1/schedule/draft/items',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteScheduleItem.fromReq = fromReq;
    __deleteScheduleItem.__isAmbassador = true;
    return __deleteScheduleItem;
}
/** Clears all changes to the draft schedule. (Does not affect the published schedule.) */
export function discardDraft(payload) {
    var _a = serializer(_discardDraftRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_discardDraftResponse, {}).fromJSON;
    function __discardDraft(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.schedule.v1.schedule_item',
            method: 'DELETE',
            methodFqn: 'wix.events.schedule.ScheduleManagement.DiscardDraft',
            url: resolveWixEventsScheduleScheduleManagementUrl({
                protoPath: '/v1/schedule/draft',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __discardDraft.fromReq = fromReq;
    __discardDraft.__isAmbassador = true;
    return __discardDraft;
}
/** Publishes the draft schedule. */
export function publishDraft(payload) {
    var _a = serializer(_publishDraftRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_publishDraftResponse, {}).fromJSON;
    function __publishDraft(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.schedule.v1.schedule_item',
            method: 'POST',
            methodFqn: 'wix.events.schedule.ScheduleManagement.PublishDraft',
            url: resolveWixEventsScheduleScheduleManagementUrl({
                protoPath: '/v1/schedule/publish',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __publishDraft.fromReq = fromReq;
    __publishDraft.__isAmbassador = true;
    return __publishDraft;
}
/** Adjusts time of all draft schedule items (per event). */
export function rescheduleDraft(payload) {
    var _a = serializer(_rescheduleDraftRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rescheduleDraftResponse, {}).fromJSON;
    function __rescheduleDraft(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.schedule.v1.schedule_item',
            method: 'POST',
            methodFqn: 'wix.events.schedule.ScheduleManagement.RescheduleDraft',
            url: resolveWixEventsScheduleScheduleManagementUrl({
                protoPath: '/v1/schedule/draft/reschedule',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __rescheduleDraft.fromReq = fromReq;
    __rescheduleDraft.__isAmbassador = true;
    return __rescheduleDraft;
}
/** Retrieves a list of bookmarked schedule items for current member. */
export function listBookmarks(payload) {
    var _a = serializer(_listBookmarksRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listBookmarksResponse, {
        _scheduleItem: _scheduleItem,
        _timeInterval: _timeInterval,
    }).fromJSON;
    function __listBookmarks(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.schedule.v1.schedule_item',
            method: 'GET',
            methodFqn: 'wix.events.schedule.BookmarkManagement.ListBookmarks',
            url: resolveWixEventsScheduleBookmarkManagementUrl({
                protoPath: '/v1/schedule/bookmarks',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listBookmarks.fromReq = fromReq;
    __listBookmarks.__isAmbassador = true;
    return __listBookmarks;
}
/** Bookmarks schedule item for current member. */
export function createBookmark(payload) {
    var _a = serializer(_createBookmarkRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createBookmarkResponse, {}).fromJSON;
    function __createBookmark(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.schedule.v1.schedule_item',
            method: 'POST',
            methodFqn: 'wix.events.schedule.BookmarkManagement.CreateBookmark',
            url: resolveWixEventsScheduleBookmarkManagementUrl({
                protoPath: '/v1/schedule/{itemId}/bookmark',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createBookmark.fromReq = fromReq;
    __createBookmark.__isAmbassador = true;
    return __createBookmark;
}
/** Removes schedule item bookmark from current member. */
export function deleteBookmark(payload) {
    var _a = serializer(_deleteBookmarkRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteBookmarkResponse, {}).fromJSON;
    function __deleteBookmark(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.schedule.v1.schedule_item',
            method: 'DELETE',
            methodFqn: 'wix.events.schedule.BookmarkManagement.DeleteBookmark',
            url: resolveWixEventsScheduleBookmarkManagementUrl({
                protoPath: '/v1/schedule/{itemId}/bookmark',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteBookmark.fromReq = fromReq;
    __deleteBookmark.__isAmbassador = true;
    return __deleteBookmark;
}
//# sourceMappingURL=http.impl.js.map